import { __assign, __rest } from "tslib";
// DS: i1.2
import React from 'react';
import IconWrap from '../IconWrap';
var CoreIconSmall = function (_a) {
    var circleClassName = _a.circleClassName, props = __rest(_a, ["circleClassName"]);
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { transform: "translate(2 2)", fill: "none", fillRule: "evenodd" },
                React.createElement("circle", { fill: "#EF6D5D", cx: "10", cy: "10", r: "10", className: circleClassName }),
                React.createElement("path", { fill: "#FFF", d: "M10.182 13.75l-3.821 2.009.73-4.255L4 8.491l4.272-.62L10.182 4l1.91 3.871 4.272.62-3.091 3.013.729 4.255z" })))));
};
CoreIconSmall.displayName = 'CoreIconSmall';
export default CoreIconSmall;
//# sourceMappingURL=CoreIconSmall.js.map